import { useTranslation } from 'react-i18next';
import React from 'react';
import { IBookingStats } from '../../../../../model/campaign/Campaign';
import { numberFormatter } from '../../../../../utils/helpers/numberFormater';

interface ICampaignChildDashCardProps {
    stats?: Partial<IBookingStats>;
    isBundleCard?: boolean;
}

export function CampaignChildDashCard({ stats, isBundleCard }: ICampaignChildDashCardProps) {
    const { t } = useTranslation();

    return (
        <>
            <div className="d-flex flex-wrap align-items-center justify-content-between border-bottom pb-4 my-3">
                <div className="col-6 col-md px-0">
                    <h3 className="text-primary">{stats?.totalContracts ?? '-'}</h3>
                    <p className="mb-0">{t('brand.campaign.dashboard.booking.long_influencers')}</p>
                </div>
                <div className="col-6 col-md px-0">
                    <div className="d-flex align-items-center">
                        <h3 className="text-primary">{stats?.contractUsedPostings ?? '-'}</h3>
                        <h3>/{stats?.totalContractPostings ?? '-'}</h3>
                    </div>
                    <p className="mb-0">{t('brand.campaign.dashboard.booking.postings_util')}</p>
                </div>
                <div className="col-6 col-md px-0">
                    <h3 className="text-primary">{numberFormatter(stats?.reach ?? 0)}</h3>
                    <p className="mb-0">{t('brand.campaign.dashboard.booking.estimeted_reach')}</p>
                </div>
                {!isBundleCard ? (
                    <div className="col-6 col-md px-0">
                        <h3 className="text-primary euro-symbol">{stats?.avgCpm ?? '-'}</h3>
                        <p className="mb-0">{t('brand.campaign.dashboard.booking.average_cpm')}</p>
                    </div>
                ) : (
                    <div></div>
                )}
            </div>
            <h6 className="text-muted">
                {isBundleCard
                    ? t('brand.campaign.dashboard.booking.additional_infl')
                    : t('brand.campaign.dashboard.booking.additional_bookings')}
            </h6>
        </>
    );
}
